import React, { Fragment, useEffect, useState } from 'react';
import pageStylePops from './SixDigitInput.module.css';

const SixDigitInput = (props) => {
    const [digits, setDigits] = useState(new Array(6).fill(""));

    useEffect(() => {
        // Set focus to the rightmost input (first input from the right)
        document.getElementById(`digit-5`).focus();
    }, []);

    const handleChange = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]{0,1}$/.test(value)) {
            const newDigits = [...digits];
            newDigits[index] = value;
            setDigits(newDigits);
            props.setTheDigist(newDigits);

            // Move to the previous input box if a digit is entered (right to left)
            if (value && index > 0) {
                document.getElementById(`digit-${index - 1}`).focus();
            }


        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !digits[index] && index < 5) {
            // Move to the next input box on Backspace (right to left)
            document.getElementById(`digit-${index + 1}`).focus();
        }
    };

    return (
        <div className={pageStylePops.contWrap}>
            {digits.map((digit, index) => (
                <span key={index}>
                    <input

                        id={`digit-${index}`}
                        className={pageStylePops.digitInput}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        maxLength="1"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"

                    />
                    {(index === 2) ? "-" : ""}
                </span>
            ))}
        </div>
    );
};



export default SixDigitInput;
